export default __webpack_public_path__ + "static/media/Gloves of Tranquility.96723ecf.jpg";